export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";